var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dropdown',{attrs:{"icon":'fas fa-user',"items":_vm.items,"actions":_vm.actions,"menu-position":'br',"show-selected":false},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }